angular.module('iqxCore')
.filter('shiftsonly', [ function() {
    return function (object) {
        var array = [];
        angular.forEach(object, function (shift) {
            if (shift.VacType == 'SV')
                array.push(shift);
        });
        return array;
    };
}])